module.exports = __webpack_public_path__ + "img/HQ-Z7035-V1-V3-All.daaffb3f.jpg";